module.exports = __webpack_public_path__ + "img/1264w.27ac6b0.jpg";